// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardUserAssignment\ApiTopicCardUserAssignment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';

// TopicCardUserAssignmentData is the class that TopicCardUserAssignment serializes to/from
export interface TopicCardUserAssignmentData {
    CardId : number;
    UserId : number;
	
    Card : TopicCardData | null;
    User : PCUserData | null;
	
}

// TopicCardUserAssignmentOptions is the class which may be passed to the TopicCardUserAssignment constructor to define optional initial data values
export interface TopicCardUserAssignmentOptions {
    CardId : number;
    UserId : number;
	
    Card? : TopicCardOptions | null;
    User? : PCUserOptions | null;
	
}

export class TopicCardUserAssignment {
    public CardId : DataSignal<number>;
    public UserId : DataSignal<number>;
	
    public Card : DataSignal<TopicCard | null>;
    public User : DataSignal<PCUser | null>;
	

    constructor();
    constructor(data : TopicCardUserAssignmentOptions);
    constructor(data: TopicCardUserAssignmentOptions | null = null) {
        this.CardId = jsonableObservable(S.value<number>(data && data.CardId !== undefined ? data.CardId : 0));
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Card = S.value<TopicCard | null>(null);
        this.User = S.value<PCUser | null>(null);
	    
    }

    static key(obj : TopicCardUserAssignment) {
        return obj.CardId() + '\u2618' + obj.UserId();
    }
    
    static dataKey(obj : TopicCardUserAssignmentOptions) {
        return obj.CardId + '\u2618' + obj.UserId;
    }

    static update(obj : TopicCardUserAssignment, data : TopicCardUserAssignmentOptions) {
        S.freeze(() => {
            if (data.CardId !== undefined) obj.CardId(data.CardId);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardUserAssignment.ts